module.exports = __webpack_public_path__ + "static/media/date wise fee icon.62c7a251.svg";